import { Link, useNavigate, Route, Routes } from 'react-router-dom';
import { useState } from 'react'; 
import { useEffect } from 'react';
import './UserLogInPage.css';
import Registrationdetails from '../Pages/Registrationdetails';
import ChooseDesForLoggedInUser from '../Pages/Designes  FOLDER/Designsecond components/ChooseDesForLoggedInUser'; 
import api from '../Pages/Login and Sign UP/api.js'; 
 
let UserLogInPage =(props)=> {
let navigate = useNavigate();
let [userdata, setuserdata] = useState('');
let [fullName, setfullName] = useState('');
let [fathername, setfathername] = useState('');
let [mothername, setmothername] = useState('');
let [dob, setdob]= useState('')
let [email, setemail]= useState('')

let [address, setaddressdata]= useState('')
let [houseno, sethouseno]= useState('')
let [village, setvillage]= useState('')
let [post, setpostoffice]= useState('')
let [thana, setthana]= useState('')
let [dist, setdistrict]= useState('')
let [state, setstate]= useState('')
let [pincod, setpincode]= useState('')

let [contact, setcontactdata]= useState('')
let [newalternatenum, setnewalternatenum]= useState('')
let [newmobilenum, setnewmobilenum]= useState('')

let [passprot, setpassportdata]= useState('')
let [passportId, setpassportId]= useState('')
let [passportnumber, setpassportnumber]= useState('')
let [issuingdate, setissudate]= useState('')
let [district, setdist]= useState('')
let [expirydate, setexpirydate]= useState('')

let [physical, setphysical]= useState('')
let [physicalId, setphysicalId]= useState('')
let [height, setheight]= useState('')
let [weight, setweight]= useState('')
let [bloodgroup, setbloodgroup]= useState('')
let [PwpDisability, setpwpdisability]= useState('')

let [Academic, setacademci]= useState([''])
let [academicId, setacademicId]=useState('')
let [Stream, setstream]= useState('')
let [BoardUnivercity, setboarduni]= useState('')
let [Passingyear, setpassyear]= useState('')
let [Percentage, setpercent]= useState('')

let [Computer, setcomdata]= useState([''])
 
let [comId, setcomId]=useState('')
let [ExamName, setexamname]=useState('')
let [From, setfrom]=useState('')
let [PassingYear, setcompassyear]=useState('')
let [PercentAge, setcompercent]=useState('')

let [Technical, settechnicaldata]= useState([''])
let [technicalId, settechnicalId]= useState('')
let [tecExamName, settecExamName]= useState('')
let [tecFromWhere, setFromWhere]= useState('')
let [tecTradeName, setTradeName]= useState('')
let [tecPassingYear, setPassingYear]= useState('')
let [tecPercentage, setPercentage]= useState('')

let [WorkExp, setworkexp]= useState([''])
let [workedyears, setWorkedyears]=useState('')
let [workingas, setWorkingas]=useState('')
let [compnmndaddress, setcompnmndaddr]=useState('')
let [period, setperiods]=useState('')
let [workexpId, setworkexpId]=useState('')

let [AllDesigns, setDesignes] = useState([''])
let [MyResume, setMyResumes] = useState(['']);
 

let [avatar, setavater]= useState(null);

let apigetalldata =async()=>{
        try {
        const resp = await api.get("/userdatapage.php");
        
        setDesignes(resp.data?.alldes);
        setMyResumes(resp.data?.myresume)
        setuserdata(resp.data?.loogedinuser);
        setfullName(resp.data?.loogedinuser.fullName)
        setfathername(resp.data?.loogedinuser.fathername)
        setmothername(resp.data?.loogedinuser.mothername)
        setdob(resp.data?.loogedinuser.dob)
        setemail(resp.data?.loogedinuser.email)

        setaddressdata(resp.data?.address)
        sethouseno(resp.data.address?.houseno)
        setvillage(resp.data.address?.village)
        setpostoffice(resp.data.address?.post)
        setthana(resp.data.address?.thana)
        setdistrict(resp.data.address?.district)
        setstate(resp.data.address?.state)
        setpincode(resp.data.address?.pincode)

        setcontactdata(resp.data?.contact)
        setnewalternatenum(resp.data.contact?.alternatenum)
        setnewmobilenum(resp.data.contact?.mobilenum)

        setphysical(resp.data?.physical)
        setheight(resp.data.physical?.height)
        setweight(resp.data.physical?.weight)
        setbloodgroup(resp.data.physical?.bloodgroup)
        setpwpdisability(resp.data.physical?.PwpDisability)

        setpassportdata(resp.data?.passport)
        setpassportnumber(resp.data?.passport.passportnumber)
        setissudate(resp.data?.passport.issuingDate)
        setdist(resp.data?.passport.district)
        setexpirydate(resp.data?.passport.expiryDate)

        setacademci(resp.data?.academic);
        setacademicId(resp.data.academic?.id);
        setcomdata(resp.data?.computer);
        settechnicaldata(resp.data?.techdata);
        setworkexp(resp.data?.workdata);
        } catch (error) {
            
            props.Successandrerrorfun("", "Your session expired... Please Login again");
            setTimeout(() => {
                localStorage.setItem("login", "");
                localStorage.setItem("loginStatus", "Loggedout successfully");
                localStorage.setItem("token" , "");
                navigate("../LoginPage");
            }, 3000);
             
        }
    
    }  








    
    let checkempty=()=>{  
        if(Academic[0].id){
            document.querySelector(".Academichide").style.display = "block";
        }
        if(Computer[0].id){
            document.querySelector(".computerhide").style.display = "block";
        }
        if(Technical[0].id){
            document.querySelector(".Techdatahide").style.display = "block";
        }
        if(WorkExp[0].id){
            document.querySelector(".workexphide").style.display = "block";
        }
        if(address !=''){
             document.querySelector(".Addresshideifempty").style.display = "block";
        }

 
    if(passprot.userid){
        document.querySelector(".passporthide").style.display = "block";
    }
    if(physical.userid){
        document.querySelector(".physicalhide").style.display = "block";
    }


    }
    checkempty();  
useEffect(()=>{
    apigetalldata(); 
},[]); 
let Logouthandler=()=>{
    localStorage.setItem("login", "");
    localStorage.setItem("loginStatus", "Loggedout successfully");
    localStorage.setItem("token" , "");
    navigate("../LoginPage");
}
let Dashboard=()=>{
    document.querySelector(".Dashboard").style.display = "block";
    document.querySelector(".myresume").style.display = "none";
    document.querySelector(".makeresume").style.display = "none";
    document.querySelector(".designs").style.display = "none";
    document.querySelector(".profile").style.display = "none";
    document.querySelector(".setting").style.display = "none";
    
}
let myresume=()=>{
    document.querySelector(".myresume").style.display = "block";
    document.querySelector(".Dashboard").style.display = "none";
    document.querySelector(".makeresume").style.display = "none";
    document.querySelector(".designs").style.display = "none";
    document.querySelector(".profile").style.display = "none";
    document.querySelector(".setting").style.display = "none";
}
let makeresume=()=>{
    document.querySelector(".myresume").style.display = "none";
    document.querySelector(".Dashboard").style.display = "none";
    document.querySelector(".makeresume").style.display = "block";
    document.querySelector(".designs").style.display = "none";
    document.querySelector(".profile").style.display = "none";
    document.querySelector(".setting").style.display = "none";
}
let Designs=()=>{
    document.querySelector(".designs").style.display = "block";
    document.querySelector(".Dashboard").style.display = "none";
    document.querySelector(".makeresume").style.display = "none";
    document.querySelector(".myresume").style.display = "none";
    document.querySelector(".profile").style.display = "none";
    document.querySelector(".setting").style.display = "none";
    
}
let profile=()=>{
    document.querySelector(".myresume").style.display = "none";
    document.querySelector(".Dashboard").style.display = "none";
    document.querySelector(".makeresume").style.display = "none";
    document.querySelector(".designs").style.display = "none";
    document.querySelector(".profile").style.display = "block";
    document.querySelector(".setting").style.display = "none";
}
let setting=()=>{
    document.querySelector(".myresume").style.display = "none";
    document.querySelector(".Dashboard").style.display = "none";
    document.querySelector(".makeresume").style.display = "none";
    document.querySelector(".designs").style.display = "none";
    document.querySelector(".profile").style.display = "none";
    document.querySelector(".setting").style.display = "block";
    
}
 

let menuclick=()=>{
    document.querySelector(".bxs-chevron-right-circle").style.display="none";
    let elm = document.querySelector(".dashleft");
        elm.style.cssText = "width: 250px;";
        
        document.querySelector(".bxs-chevron-left-circle").style.display = "block";  
}
let leftchevronclick=()=>{
    let elm = document.querySelector(".dashleft");
        elm.style.cssText = "width: 34px;";
        document.querySelector(".bxs-chevron-right-circle").style.display="block";
        document.querySelector(".bxs-chevron-left-circle").style.display = "none";
     
}
//  -------------------------------------------------------------------
// -------------------------Update method userdata------------------------------
const userdataupdatehandler=async(e)=>{
    e.preventDefault()
   
    let userdataformdata = new FormData();
    userdataformdata.append('id', userdata.id);
    userdataformdata.append('fullName',fullName)
    userdataformdata.append('fathername',fathername)   
    userdataformdata.append('mothername',mothername)    
    userdataformdata.append('dob',dob)       
    try {
      const response = await api.post('/userdataupdate.php', userdataformdata)
        props.Successandrerrorfun(response.data.result, "")
        apigetalldata();
        
    } catch (error) {
     console.log(error)    
     props.Successandrerrorfun("","User data not updated")
    }
 }
 let hideusereditsec=()=>{
    document.querySelector(".EditUserDetailsCont").style.display="none"
 }
 let unhideusereditsec=()=>{
    document.querySelector(".EditUserDetailsCont").style.display="block"

 }
//  ----------------------------------------------------------------------
// ---------------------------Update address-------------------------------
const addressupdatehandler=async(e)=>{
    e.preventDefault()
    let addrupdateformdata = new FormData();
    addrupdateformdata.append('userid', userdata.id);
    addrupdateformdata.append('houseno', houseno);
    addrupdateformdata.append('village', village);
    addrupdateformdata.append('post',post);
    addrupdateformdata.append('thana',thana);
    addrupdateformdata.append('district',dist);
    addrupdateformdata.append('state',state);
    addrupdateformdata.append('pincode',pincod);
    try {
      const response = await api.post('/updateusersaddress.php', addrupdateformdata);
        props.Successandrerrorfun(response.data.result, "");
        apigetalldata();
         
       
          
      
    } catch (error) {
     console.log(error)
     props.Successandrerrorfun("","Address not updated")
    }
 }
 let hideaddresseditsection=()=>{
    document.querySelector(".EditAddressDetailsCont").style.display="none"
 }
 let unhideaddreseditsec=()=>{
    document.querySelector(".EditAddressDetailsCont").style.display="block"
 }
//  ----------------------------------------------------------------------
// -------------------------Update contact-------------------------------
const contactupdatehandler=async(e)=>{
    e.preventDefault()
     
    let contactformdata=  new FormData();
    contactformdata.append('userid', userdata.id);
    contactformdata.append('mobilenum', newmobilenum)
    contactformdata.append('email', email)
    contactformdata.append('alternatenum', newalternatenum)
    try {
      const response = await api.post('/updatecontact.php', contactformdata);
      apigetalldata();
      props.Successandrerrorfun(response.data.result, "");
    } catch (error) {
     console.log(error)
     props.Successandrerrorfun("","Address not updated")
    }
}
let Unhidecontacteditsec=()=>{
    if(!contact.userid){
        props.Successandrerrorfun("", "Mobile contacts not exist");
        return;
    }
    document.querySelector(".EditContactDetailsCont").style.display="block"
}
let hidecontacteditsec=()=>{
    document.querySelector(".EditContactDetailsCont").style.display="none"
}
//  ---------------------------------------------------------------------------
// ---------------------------Update passport------------------------------
const passporupdatehandler=async(e)=>{
    e.preventDefault()
    let passformdata = new FormData();
    passformdata.append('userid', userdata.id);
    passformdata.append('passportnumber',passportnumber)
    passformdata.append('issuingDate',issuingdate)
    passformdata.append('expiryDate', expirydate)
    passformdata.append('district', district)
    try {
      const response = await api.post('/updateuserspassport.php', passformdata);
      apigetalldata();
        props.Successandrerrorfun(response.data.result, "");
    } catch (error) {
     console.log(error);
     props.Successandrerrorfun("","Passport data not updated");
     
    }
 }
 let hidepasseditsec=()=>{
    document.querySelector(".EditPassportDetailsCont").style.display="none"

 }
 let unhidepasseditsec=()=>{
    document.querySelector(".EditPassportDetailsCont").style.display="block"

 }
//  ------------------------------------------------------------------------
// -----------------------------Update physical data--------------------------
const physicalupdatehandler=async(e)=>{
    e.preventDefault()
    let physicalformdata = new FormData();
    physicalformdata.append('userid', userdata.id);
    physicalformdata.append('height', height)
    physicalformdata.append('weight', weight)
    physicalformdata.append('bloodgroup', bloodgroup)
    physicalformdata.append('PwpDisability',PwpDisability)
    try {
      const response = await api.post('/updateusersphysical.php', physicalformdata);
      apigetalldata();
        props.Successandrerrorfun(response.data.result, "")
    } catch (error) {
        props.Successandrerrorfun("","Physical data not updated")
        console.log(error)
    }
 }
 let hidephycancelbtn=()=>{
    document.querySelector(".EditphysicalDetailsCont").style.display="none"
 }
 let unhidephyeditsec=()=>{
    document.querySelector(".EditphysicalDetailsCont").style.display="block"
 }
//  --------------------------------------------------------------------
// --------------------------Update academicId data--------------------
let selsectitem=(acdmData)=>{
    document.querySelector(".Academichide").style.display="block";
    document.querySelector(".EditAcademicDetailsCont").style.display="block"
    setacademicId(acdmData.id)
    setstream(acdmData.Stream)
    setboarduni(acdmData.BoardUnivercity)
    setpassyear(acdmData.Passingyear)
    setpercent(acdmData.Percentage)
    
}
let Academicupdatehandler=async()=>{ 
    let academcidataupdateform = new FormData();
    academcidataupdateform.append('userid', userdata.id);
    academcidataupdateform.append('id', academicId);
    academcidataupdateform.append('stream',Stream)
    academcidataupdateform.append('boardUniverciy', BoardUnivercity)
    academcidataupdateform.append('Passingyear', Passingyear)
    academcidataupdateform.append('Percentage', Percentage)
    
    try {
        const response = await api.post('/updateacademicdata.php', academcidataupdateform);
            apigetalldata();
            props.Successandrerrorfun(response.data.result, "")
         
            
        
      } catch (error) {
       console.log(error)
       props.Successandrerrorfun("","Academic data not updated")
      }

    setstream('')
    setboarduni('')
    setpassyear('')
    setpercent('')

}
let deleteacadata=async(id)=>{
    if(Academic.length == 1){
        document.querySelector(".Academichide").style.display = "none";
    }
    let deleteacademcidata = new FormData();
    deleteacademcidata.append('id', id)
    try {
        const response = await api.post('/deleteacademicdata.php', deleteacademcidata);
        apigetalldata();
        props.Successandrerrorfun(response.data.result, "");
             
         
            
       
    } catch (error) {
        console.log(error)
        props.Successandrerrorfun("", "Academic data not deleted")
    }

}
let hidecancelbtn=()=>{
    document.querySelector(".EditAcademicDetailsCont").style.display="none"
}
//  ----------------------------------------------------------------------
// ---------------------------------Update computer data----------------
let selseccomtitem=(comData)=>{
    document.querySelector(".EditcomDetailsCont").style.display="block"
    setcomId(comData.id)
    setexamname(comData.ExamName)
    setcompassyear(comData.PassingYear)
    setcompercent(comData.PercentAge)
    setfrom(comData.from)

}
let computerupdatehandler=async()=>{
    let comdataupdate = new FormData();
    comdataupdate.append('id', comId)
    comdataupdate.append('userid', userdata.id)
    comdataupdate.append('ExamName',ExamName)
    comdataupdate.append('from',From)
    comdataupdate.append('PassingYear', PassingYear)
    comdataupdate.append('PercentAge', PercentAge)
    try {
        const response = await api.post('/updatecomputerdata.php', comdataupdate); 
        apigetalldata();
        props.Successandrerrorfun(response.data.result, "")
        
            
        
      } catch (error) {
        props.Successandrerrorfun("", "Computer data not updated")
       console.log(error)
      }
    setexamname('')
    setfrom('')
    setcompassyear('')
    setcompercent('')

}
let deletecomdata=async(id)=>{
    if(Computer.length == 1){
        document.querySelector(".computerhide").style.display = "none";
    }
     let deletecomputerdata = new FormData();
    deletecomputerdata.append('id', id)
    try {
        const response = await api.post('/deletecomputerdata.php',deletecomputerdata );
            apigetalldata();
            props.Successandrerrorfun(response.data.result, "")
            
       
            
        
    } catch (error) {
        console.log(error)
        props.Successandrerrorfun("", "Computer data not deleted")
    }

}
let hiecomcancelbtn=()=>{
    document.querySelector(".EditcomDetailsCont").style.display="none"
}
// ---------------------------------------------------------------------------
// -----------------------Update Technical data------------------------------
let selecttechitem=(tecData)=>{
    document.querySelector(".EdittecDetailsCont").style.display="block"
    settechnicalId(tecData.id)
    settecExamName(tecData.ExamName)
    setFromWhere(tecData.FromWhere)
    setTradeName(tecData.TradeName)
    setPassingYear(tecData.PassingYear)
    setPercentage(tecData.Percentage)


}
let technicalupdatehandler=async()=>{
    let techdataafrom = new FormData();
    techdataafrom.append('id', technicalId)
    techdataafrom.append('ExamName',tecExamName)
    techdataafrom.append('FromWhere',tecFromWhere)
    techdataafrom.append('TradeName',tecTradeName)
    techdataafrom.append('PassingYear',tecPassingYear)
    techdataafrom.append('userid', userdata.id)
    techdataafrom.append('Percentage',tecPercentage)
    try {
        const response = await api.post('/updatetechnicaldata.php', techdataafrom);
            apigetalldata();
            props.Successandrerrorfun(response.data.result, "")
       
            
        
      } catch (error) {
       console.log(error)
       props.Successandrerrorfun("","Technical data not updated")
      }
      settecExamName('')
      setFromWhere('')
      setTradeName('')
      setPassingYear('')
      setPercentage('')
}
let deletetechdata=async(id)=>{
    if(Technical.length == 1){
        document.querySelector(".Techdatahide").style.display = "none";
    }
     let deletetechnicaldata = new FormData();
    deletetechnicaldata.append('id', id)
    try {
        const response = await api.post('/deletechnicaldata.php', deletetechnicaldata);
          apigetalldata();
            props.Successandrerrorfun(response.data.result, "")
            
         
    } catch (error) {
        console.log(error)
        props.Successandrerrorfun("", "Technical data not deleted")
    }

}
let hieteccancelbtn=()=>{
    document.querySelector(".EdittecDetailsCont").style.display="none"
}
// -------------------------------------------------------------------------
// --------------------------Update workexp data---------------------------
let selectworkitem=(workData)=>{
    document.querySelector(".EditworkDetailsCont").style.display="block"
    setworkexpId(workData.id)
    setWorkedyears(workData.WorkedYears)
    setWorkingas(workData.WorkingAs)
    setcompnmndaddr(workData.CompanyNameAndAddress)
    setperiods(workData.WorkedPeriod)

}
let workedexpupdatehandler=async()=>{
     let workexpformdata = new FormData();
    workexpformdata.append('id', workexpId)
    workexpformdata.append('userid', userdata.id)
    workexpformdata.append('WorkedYears',workedyears)
    workexpformdata.append('WorkingAs',workingas)
    workexpformdata.append('CompanyNameAndAddress',compnmndaddress)
    workexpformdata.append('WorkedPeriod',period)
    try {
        const response = await api.post('/updateworkexp.php', workexpformdata); 
            
            apigetalldata();
            props.Successandrerrorfun(response.data.result, "")
        
           
        
      } catch (error) {
       console.log(error)
        props.Successandrerrorfun("","WorkExp data not updated")
      }
      setWorkedyears('')
      setWorkingas('')
      setcompnmndaddr('')
      setperiods('')
      

}
let deleteworkdata=async(id)=>{
    if(WorkExp.length == 1){
        document.querySelector(".workexphide").style.display = "none";
    }
     let deleteworkexpdata = new FormData();
    deleteworkexpdata.append('id', id)
    try {
        const response = await api.post('/deleteworkexp.php', deleteworkexpdata);
         apigetalldata();
        props.Successandrerrorfun(response.data.result, "")
             
        
           
        
    } catch (error) {
        console.log(error)
         props.Successandrerrorfun("", "WorkExp data not deleted")
    }

}
let hieworkcancelbtn=()=>{
    document.querySelector(".EditworkDetailsCont").style.display="none"
}
// ------------------------------------------------------------------------------------
// -----------------Get All Designes--------------------------------------------
 let changeabatarhandler = async(e)=>{
    e.preventDefault()
    if(avatar== null){
        props.Successandrerrorfun("", "Please select Photo");
        return;
    }
    const formdata = new FormData()
    formdata.append('avatar', avatar);
    formdata.append('userid', userdata.id);
   try {
     const response = await api.post('/updateprofilepic.php',formdata,); 
        props.Successandrerrorfun(response.data.result, "");
        apigetalldata();
   } catch (error) {
    console.log(error.message)
     props.Successandrerrorfun("", "Profile photo not updated")
    
   }

  

 }
 let unhide=()=>{
    document.querySelector(".update_avatar").style.display = "block"
 }
 let hide=()=>{
    document.querySelector(".update_avatar").style.display = "none"
 }
 let deletemyresdes=async(id)=>{
    let deletemyresumedata = new FormData();
    
    deletemyresumedata.append('desid', id);
    try {
        const response = await api.post('/deletemyresumes.php',deletemyresumedata)
        apigetalldata();
        props.Successandrerrorfun(response.data.result, "")
    } catch (error) {
        console.log(error)
        props.Successandrerrorfun("", "Profile photo not updated")
    }

 } 
   



 

    return( 
        <div className='userlogin_main_cont'>
            <div className='popupdiv'>
                <p style={{backgroundColor:"green", color:"white"}} className='success samemsg'></p>
                <p style={{backgroundColor:"red", color:"white"}} className='error samemsg'></p>
            </div>
            <div className='header_cont'>
                <h2>Welcome to Resume : {userdata?.fullName}</h2>
                <div className='Userdetails_cont'>
                    <img className='Userdetails_cont' src={'https://makeeasyway.in/resumeData/'+userdata?.avatar}/>
                    <div className='Details_cont'>
                        <span>UserName:-{userdata?.username}</span>
                        <span>FatherName:-{userdata?.fathername}</span>
                        <span>Email-Id:-{userdata?.email}</span>
                        <span onClick={Logouthandler}>Log Out</span> 
                    </div> 
                       
                </div>
            </div> 
            <div className='Dashboardmaincont'>
                <div className='dashleft'>
                    
                    <div className='hidesidebar'>
                        <span className='spanspan'><i style={{margin:"0", fontSize:"30px"}}  className='bx bxs-chevron-right-circle' onClick={menuclick} ></i> <i style={{margin:"0", fontSize:"30px", display:"none"}} className='bx bxs-chevron-left-circle' onClick={leftchevronclick}></i></span>
                    </div>
                    <p onClick={Dashboard} className='dashptag'><span><i title='DashBoard' className='bx bxs-dashboard'></i></span>DashBoard</p>
                    <p onClick={myresume} className='dashptag'><span><i  title='My Resumes' className='bx bx-list-check' ></i></span>My Resumes</p>
                    <Link to="Registration">
                    <p onClick={makeresume}  className='dashptag'><span><i  title='Make New Resume' className='bx bx-news'></i>Make Resume</span></p>
                    </Link>
                    <p onClick={Designs} className='dashptag'><span><i title='All Avilable Designes' className='bx bxs-data'></i></span>Designs</p>
                    <p onClick={profile} className='dashptag'><span><i title='Profile' className='bx bx-user'></i></span>Profile</p>
                    <p onClick={setting} className='dashptag'><span><i title='Setting' className='bx bx-cog' ></i></span>Setting</p>
                </div> 
                <div className='dashright' style={{overflowY:"scroll"}}>
                    <div style={{padding:"5px"}} className='Dashboard'> 
                        <h2 className='usersdashboardheading'>Users DashBoard</h2>
                        <div className='personaldata'>
 {/* -----------------------User Registrationdetails---------------*/}
                            <h3 className='personaldeahing'>Personal Details<i style={{cursor:"pointer", fontSize:"30px"}} onClick={unhideusereditsec} title='Edit' className='bx bx-edit-alt'></i></h3>
                            <div className='percont'>
                                <p className='personal_ptag'><span>FullName</span>:<span>{userdata?.fullName}</span></p>

                                <p className='personal_ptag'><span>FatherName</span>:<span>{userdata?.fathername}</span></p>

                                <p className='personal_ptag'><span>MotherName</span>:<span>{userdata?.mothername}</span></p>

                                <p className='personal_ptag'><span>Date Of Birth</span>:<span>{userdata?.dob}</span></p>

                                <p className='personal_ptag'><span>Email Id</span>:<span>{userdata?.email}</span></p>
                            </div>
 
                            <div style={{display:"none"}} className='EditUserDetailsCont'>
                                <form className='userform' onSubmit={userdataupdatehandler}>
                                    
                                    <p className='userdetptag'>Edit User Details</p>
                                    <input className='userinputs' placeholder='Full Name' type='text' onChange={(event)=>setfullName(event.target.value)} value={fullName}/>
                                    <input className='userinputs'  type='text' onChange={(event)=>setfathername(event.target.value)} value={fathername}/>
                                    <input className='userinputs'  type='text' onChange={(event)=> setmothername(event.target.value)} value={mothername}/>
                                    <input className='userinputs'  type='text' onChange={(event)=> setdob(event.target.value)} value={dob}/>
                                    <input type='submit' value="Update"/>
                                </form>
                                <div style={{textAlign:"center"}}>
                                    <button className='canclebtn' onClick={hideusereditsec}>Cancel</button>
                                </div>
                                
                            </div>
{/* ------------------------------Address Details------------------------ */}
                            <div style={{display:"none"}} className='Addresshideifempty hidesame'>
                                <h3 className='addrheading'>Address Details<i style={{cursor:"pointer", fontSize:"30px"}} onClick={unhideaddreseditsec} title='Edit' className='bx bx-edit-alt'></i></h3>
                                <div className='addresscont'>
                                    <p className='address_ptag'><span>HouseNo</span>:<span className='spanhide'>{address?.houseno??"NA"}</span></p>

                                    <p className='address_ptag'><span>Village</span>:<span className='checkempty'>{address?.village??"NA"}</span></p>

                                    <p className='address_ptag'><span>PostOffice</span>:<span>{address?.post??"NA"}</span></p>

                                    <p className='address_ptag'><span>Thana</span>:<span>{address?.thana??"NA"}</span></p>

                                    <p className='address_ptag'><span>Districe</span>:<span>{address?.district??"NA"}</span></p>

                                    <p className='address_ptag'><span>State</span>:<span>{address?.state??"NA"}</span></p>

                                    <p className='address_ptag'><span>Pin Code</span>:<span>{address?.pincode??"NA"}</span></p>
                                </div>
                                <div style={{display:"none"}} className='EditAddressDetailsCont'>
                                    <form className='addrfrom' onSubmit={addressupdatehandler}>
                                        <p style={{margin:"0"}}>Update Address</p>
                                        <input className='addrinputs' type='text' onChange={(event)=>sethouseno(event.target.value)} value={houseno}/>
                                        <input className='addrinputs'  type='text' onChange={(event)=>setvillage(event.target.value)} value={village}/>
                                        <input className='addrinputs'  type='text' onChange={(event)=> setpostoffice(event.target.value)} value={post}/>
                                        <input className='addrinputs'  type='text' onChange={(event)=> setthana(event.target.value)} value={thana}/>
                                        <input className='addrinputs'  type='text' onChange={(event)=> setdistrict(event.target.value)} value={dist}/>

                                        <input className='addrinputs'  type='text' onChange={(event)=> setstate(event.target.value)} value={state}/>
                                        <input className='addrinputs'  type='text' onChange={(event)=> setpincode(event.target.value)} value={pincod}/>
                                        <input type='submit' value="Update"/>
                                    </form>
                                    <div style={{textAlign:"center"}}>
                                        <button  className='canclebtn'  onClick={hideaddresseditsection}>Cancel</button>
                                    </div>
                                    
                                </div>
                            </div>
                            


{/* ------------------------------------Contact Details------------------------ */}
                            <div className='Contacthide hidesame'>
                                <h3 className='contactheading'>Contact Details<i onClick={Unhidecontacteditsec} title='Edit' style={{cursor:"pointer", fontSize:"30px"}}  className='bx bx-edit-alt'></i></h3>
                                <div className='addrptcont'>
                                    <p className='addr_ptag'><span>Mobile Number</span>:<span className='contactempty'>{contact?.mobilenum??"NA"}</span></p>

                                    <p className='addr_ptag'><span>Email Id</span>:<span>{userdata?.email}</span></p>
 
                                    <p className='addr_ptag'><span>Alternate Number</span>:<span>{contact?.alternatenum??"NA"}</span></p>

                                </div>
                                <div style={{display:"none"}} className='EditContactDetailsCont'>
                                    <form className='contactform' onSubmit={contactupdatehandler}>
                                    <p style={{textAlign:"center", margin:"0"}}>Edit Contact Details</p>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <td>MobileNumber</td>
                                                    <td><input className='contactinputs' type='text' onChange={(event)=>setnewmobilenum(event.target.value)} value={newmobilenum}/></td>
                                                </tr>
                                                <tr>
                                                    <td>AlternateMobNum</td>
                                                    <td>
                                                    <input  className='contactinputs' type='text' onChange={(event)=>setnewalternatenum(event.target.value)} value={newalternatenum}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Action</td>
                                                    <td>
                                                    <input type='submit' value="Update"/>
                                                    </td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </form>
                                    <div style={{textAlign:"center"}}>
                                        <button  className='canclebtn'  onClick={hidecontacteditsec}>Cancel</button>
                                    </div>
                                    
                                </div>
                            </div>
                            


{/* ---------------------------------Passport  Details-------------------------- */}
                            <div style={{display:"none"}} className='passporthide'>
                                <h3 className='passportheading'>Passport Details<i onClick={unhidepasseditsec} style={{cursor:"pointer", fontSize:"30px"}}  title='Edit' className='bx bx-edit-alt'></i></h3>
                                <div className='passpcont'>
                                    <p className='passport_ptag'><span>Passport Number</span>:<span className='passcheckemp'>{passprot?.passportnumber??"NA"}</span></p>

                                    <p className='passport_ptag'><span>Issuing Date</span>:<span>{passprot?.issuingDate??"NA"}</span></p>

                                    <p className='passport_ptag'><span>Expiry Date</span>:<span>{passprot?.expiryDate??"NA"}</span></p>

                                    <p className='passport_ptag'><span>District</span>:<span>{passprot?.district??"NA"}</span></p>

                                </div>
                                <div style={{textAlign:"center", display:"none"}} className='EditPassportDetailsCont'>
                                    <form onSubmit={passporupdatehandler}>

                                    <p style={{textAlign:"center", margin:"0"}}>Edit Passport Details</p>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <td>passport Number</td>
                                                     <td>
                                                    <input type='text' onChange={(event)=>setpassportnumber(event.target.value)} value={passportnumber}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>issuingDate</td>
                                                    <td>
                                                        <input type='text' onChange={(event)=>setissudate(event.target.value)} value={issuingdate}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>ExpiryDate</td>
                                                    <td>
                                                        <input type='text' onChange={(event)=>setdist(event.target.value)} value={district}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>District</td>
                                                    <td>
                                                        <input type='text' onChange={(event)=>setexpirydate(event.target.value)} value={expirydate}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Action</td>
                                                    <td>
                                                        <input type='submit' value="Update"/>
                                                    </td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </form>
                                    <button  className='canclebtn'  onClick={hidepasseditsec}>Cancel</button>
                                </div>
                            </div>
                            


{/* -----------------------------------Physical Details----------------------- */}
                            <div style={{display:"none"}} className='physicalhide'>
                                <h3 className='physicalheading'>Physical Details<i onClick={unhidephyeditsec} style={{cursor:"pointer", fontSize:"30px"}}  title='Edit' className='bx bx-edit-alt'></i></h3>
                                <div className='phypcont'>
                                    

                                    <p className='physical_ptag'><span>Height</span>:<span className='physicalcheckemp'>{physical?.height??"NA"}</span></p>

                                    <p className='physical_ptag'><span>Weight</span>:<span>{physical?.weight??"NA"}</span></p>

                                    <p className='physical_ptag'><span>Blood Group</span>:<span>{physical?.bloodgroup??"NA"}</span></p>

                                    <p className='physical_ptag'><span>PwPDisability</span>:<span>{physical?.PwpDisability??"NA"}</span></p>

                                </div>
                                <div style={{display:"none", textAlign:"center", margin:"10px"}} className='EditphysicalDetailsCont'>        
                                    <form onSubmit={physicalupdatehandler}>
                                    <p style={{textAlign:"center", margin:"0"}}>Edit Physical Details</p>
                                        <table>
                                                    <thead>
                                                        <tr>
                                                            <td>Height</td>
                                                             <td>
                                                            <input type='text' onChange={(event)=>setheight(event.target.value)} value={height}/>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Weight</td>
                                                             <td>
                                                            <input type='text' onChange={(event)=>setweight(event.target.value)} value={weight}/>
                                                            </td>
                                                            
                                                        </tr>
                                                        <tr>
                                                            <td>Blood Group</td>
                                                              <td>
                                                            <input type='text' onChange={(event)=>setbloodgroup(event.target.value)} value={bloodgroup}/>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>PwPDisability</td>
                                                            
                                                            <td>
                                                            <input type='text' onChange={(event)=>setpwpdisability(event.target.value)} value={PwpDisability}/>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>Action</td>
                                                             <td>
                                                            <input type='submit' value="Update"/>
                                                            </td>

                                                        </tr>
                                                    </thead>
                                                </table>
                                            </form>
                                            <button  className='canclebtn'  onClick={hidephycancelbtn}>Cancel</button>
                                </div>
                            </div>
                            
{/* ------------------------------Academic Details------------------------- */}
                            <div style={{display:"none"}}  className='Academichide hidesame'>
                                <h3  className='academicheading'>Academic Details</h3>
                                <div className='academictablecont'>
                                    <table className='academictable'>
                                        <thead>
                                            <tr>
                                                <td>Stream</td>
                                                <td>Board/Univercity</td>
                                                <td>Passing Year</td>
                                                <td>PercentAge</td>
                                                <td colSpan="2">Actions</td>
                                            
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                Academic.map(
                                                    acdmData=>(
                                                        <tr>
                                                            <td className='academiccheckemp'>{acdmData?.Stream??"NA"}</td>
                                                            <td>{acdmData?.BoardUnivercity??"NA"}</td>
                                                            <td>{acdmData?.Passingyear??"NA"}</td>
                                                            <td>{acdmData?.Percentage??"NA"}</td>


                                                            <td><i onClick={()=>selsectitem(acdmData)} style={{cursor:"pointer", fontSize:"30px"}}  title='Edit' className='bx bx-edit-alt'></i></td>
                                                            <td ><i onClick={()=>deleteacadata(acdmData.id)} style={{cursor:"pointer", fontSize:"30px"}}  title='Delete' className='bx bxs-trash-alt'></i></td>
                                                        </tr>
                                                    )
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    <div style={{display:"none"}} className='EditAcademicDetailsCont'>
                                    <p style={{textAlign:"center", margin:"0"}}>Edit Academic Details</p>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <td>Stream</td>
                                                     <td>
                                                        <input type='text' onChange={(event)=>setstream(event.target.value)} value={Stream}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Board/Univercity</td>
                                                     <td>
                                                        <input type='text' onChange={(event)=>setboarduni(event.target.value)} value={BoardUnivercity}/>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td>Passing Year</td>
                                                     <td>
                                                        <input type='text' onChange={(event)=>setpassyear(event.target.value)} value={Passingyear}/>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td>PercentAge</td>
                                                     <td>
                                                        <input type='text' onChange={(event)=>setpercent(event.target.value)} value={Percentage}/>
                                                    </td>

                                                </tr>
                                                <tr>
                                                     
                                                     
                                                     <td>
                                                        <button  className='canclebtn'  onClick={hidecancelbtn}>cancel</button>

                                                    </td>
                                                    <td>
                                                        <button  className='canclebtn'  onClick={Academicupdatehandler}>Update</button>
                                                    </td>

                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            

{/* --------------------------------Computer Data-----------------------*/}
                            <div style={{display:"none"}} className='computerhide hidesame'>
                                <h3 className='academicheading'>Computer Details</h3>
                                <div className='academictablecont'>
                                    <table className='academictable'>
                                        <thead>
                                            <tr>
                                                <td>Stream</td>
                                                <td>From</td>
                                                <td>Passing Year</td>
                                                <td>PercentAge</td>
                                                <td colSpan="2">Actions</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                Computer.map(
                                                    comData=>(
                                                <tr>
                                                    <td className='computercheckemp'>{comData?.ExamName??"NA"}</td>
                                                    <td>{comData?.from??"NA"}</td>
                                                    <td>{comData?.PassingYear??"NA"}</td>
                                                    <td>{comData?.PercentAge??"NA"}</td>
                                                    <td><i onClick={()=>selseccomtitem(comData)} style={{cursor:"pointer", fontSize:"30px"}}  title='Edit' className='bx bx-edit-alt'></i></td>
                                                    <td><i onClick={()=>deletecomdata(comData.id)} style={{cursor:"pointer", fontSize:"30px"}}  title='Delete' className='bx bxs-trash-alt'></i></td>
                                                </tr>
                                                    )
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    <div style={{display:"none"}} className='EditcomDetailsCont'>
                                    <p style={{textAlign:"center", margin:"0"}}>Edit Computer Details</p>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <td>ExamName</td>
                                                             <td>
                                                            <input type='text' onChange={(event)=>setexamname(event.target.value)} value={ExamName}/>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>From</td>
                                                             <td>
                                                            <input type='text' onChange={(event)=>setfrom(event.target.value)} value={From}/>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>PassingYear</td>
                                                             <td>
                                                            <input type='text' onChange={(event)=>setcompassyear(event.target.value)} value={PassingYear}/>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>PercentAge</td>
                                                             <td>
                                                            <input type='text' onChange={(event)=>setcompercent(event.target.value)} value={PercentAge}/>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            
                                                             <td>
                                                            <button  className='canclebtn'  onClick={hiecomcancelbtn}>cancel</button>
                                                            </td>
                                                             <td>
                                                            <button  className='canclebtn'  onClick={computerupdatehandler}>Update</button>
                                                            </td>

                                                        </tr>
                                                    </thead>
                                                </table> 
                                    </div>
                                </div>
                            </div>
                            

{/* ------------------------------Technical Data-------------------------- */}
                            <div style={{display:"none"}}  className='Techdatahide hidesame'>
                                <h3 className='academicheading'>Technical Details</h3>
                                <div className='academictablecont'>
                                    <table className='academictable'>
                                        <thead>
                                            <tr>
                                                <td>ExamName</td>
                                                <td>Trade</td>
                                                <td>Passing Year</td>
                                                <td>PercentAge</td>
                                                <td>FromWhere</td>
                                                <td colSpan="2">Actions</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                Technical.map(
                                                    tecData=>(
                                                <tr>
                                                    <td className='techcheckemp'>{tecData?.ExamName??"NA"}</td>
                                                    <td>{tecData?.TradeName??"NA"}</td>
                                                    <td>{tecData?.PassingYear??"NA"}</td>
                                                    <td>{tecData?.Percentage??"NA"}</td>
                                                    <td>{tecData?.FromWhere??"NA"}</td>
                                                    <td><i onClick={()=>selecttechitem(tecData)} style={{cursor:"pointer", fontSize:"30px"}}  title='Edit' className='bx bx-edit-alt'></i></td>
                                                    <td><i onClick={()=>deletetechdata(tecData.id)} style={{cursor:"pointer", fontSize:"30px"}}  title='Delete' className='bx bxs-trash-alt'></i></td>
                                                </tr>
                                                    )
                                                )
                                            }
                                        </tbody>
                                    </table>


                                    <div style={{display:"none"}} className='EdittecDetailsCont'>
                                        <p style={{textAlign:"center", margin:"0"}}>Edit Technical Details</p>
                                        <table>
                                                    <thead>
                                                        <tr>
                                                            <td>ExamName</td>
                                                            <td>
                                                            <input type='text' onChange={(event)=>settecExamName(event.target.value)} value={tecExamName}/>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>TradeName</td>
                                                             <td>
                                                            <input type='text' onChange={(event)=>setTradeName(event.target.value)} value={tecTradeName}/>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>PassingYear</td>
                                                             <td>
                                                            <input type='text' onChange={(event)=>setPassingYear(event.target.value)} value={tecPassingYear}/>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>PercentAge</td>
                                                             <td>
                                                            <input type='text' onChange={(event)=>setPercentage(event.target.value)} value={tecPercentage}/>
                                                            </td>

                                                        </tr>
                                                         <tr>
                                                            <td colSpan="4">From:-
                                                            <input type='text' onChange={(event)=>setFromWhere(event.target.value)} value={tecFromWhere}/>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                             <td>
                                                            <button  className='canclebtn'  onClick={hieteccancelbtn}>Cancel</button>
                                                            </td>
                                                             <td> 
                                                                <button  className='canclebtn'  onClick={technicalupdatehandler}>Update</button>
                                                                
                                                            </td>
                                                           

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            
                                                           
                                                           
                                                           
                                                           
                                                        </tr>
                                                       
                                                    </tbody>
                                                </table>
                                        </div>
                                </div>
                            </div>

                            
{/* ------------------------------WorkExperiance Data ---------------------- */}
                            <div style={{display:"none"}}  className='workexphide hidesame'>
                                <h3 className='academicheading'>WorkExperiance Details</h3>
                                <div className='academictablecont'>
                                    <table className='academictable'>
                                        <thead>
                                            <tr>
                                                <td>Worked Years</td>
                                                <td>Working As</td>
                                                <td>CompanyName/Address</td>
                                                <td>Period</td>
                                                <td colSpan="2">Actions</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                WorkExp.map(
                                                    workData=>(
                                                <tr>
                                                    <td className='workcheckemp'>{workData?.WorkedYears??"NA"}</td>
                                                    <td>{workData?.WorkingAs??"NA"}</td>
                                                    <td>{workData?.CompanyNameAndAddress??"NA"}</td>
                                                    <td>{workData?.WorkedPeriod??"NA"}</td>
                                                    <td><i   onClick={()=>selectworkitem(workData)} style={{cursor:"pointer", fontSize:"30px"}}  title='Edit' className='bx bx-edit-alt'></i></td>
                                                    <td><i onClick={()=>deleteworkdata(workData.id)} style={{cursor:"pointer", fontSize:"30px"}}  title='Delete' className='bx bxs-trash-alt'></i></td>
                                                </tr>
                                                    )
                                                )
                                            }
                                        </tbody>
                                    </table>
                                        <div style={{display:"none"}} className='EditworkDetailsCont'>
                                        <p style={{textAlign:"center", margin:"0"}}>Edit WorkExp Details</p>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <td>WorkedYears</td>
                                                     <td>
                                                    <input type='text' onChange={(event)=>setWorkedyears(event.target.value)} value={workedyears}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>WorkingAs</td>
                                                     <td>
                                                    <input type='text' onChange={(event)=>setWorkingas(event.target.value)} value={workingas}/>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td>company/Address</td>
                                                     <td>
                                                    <input type='text' onChange={(event)=>setcompnmndaddr(event.target.value)} value={compnmndaddress}/>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td>Period</td>
                                                     <td>
                                                    <input type='text' onChange={(event)=>setperiods(event.target.value)} value={period}/>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td>
                                                    <button className='canclebtn'  onClick={hieworkcancelbtn}>Cancel</button>
                                                    </td>
                                                    
                                                    <td>
                                                    <button  className='canclebtn' onClick={workedexpupdatehandler}>Update</button>
                                                    </td>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                   
                                                   
                                                   
                                                   
                                                   
                                                </tr>
                                            </tbody>
                                        </table>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div style={{display:"none"}} className='myresume'>
                    <p style={{textAlign:"center", borderBottom:"2px solid black", margin:"0", padding:"6px"}}>My Resumes </p>
                    <div className='designs_main_cont'>
                        
                            {
                                MyResume[0] !== '' ?  MyResume.map(
                                    deslink=>(
                                         
                                        <a target="_blank" title='MyResumes'    className='desi_cont'>
                                            <i onClick={()=>deletemyresdes(deslink?.desid)} style={{cursor:"pointer"}}  title='Delete' className='bx myresdel bxs-trash-alt'></i>
                                            <img className='image' alt={deslink?.alt} src={deslink?.desimage}/>
                                            <p className='imghead'>{deslink?.description}</p>
                                        </a>
                                    ) 
                                ) : "If you want to reprint Please fill form"
                            }
                    </div>
                     
                    </div>
                    <div  className='makeresume'>
                    {/* <p>Make Resume</p> */}
                        <div className='form_container'>
                            <Routes>
                            <Route path='Registration' element={<Registrationdetails     
                                Apiregdata={userdata}
                               
                                Addrdata={address}
                                contactdata={contact}
                                Successandrerrorfun={props.Successandrerrorfun}
                                Getphydata={props.Getphydata} 
                                Getpasspoetdata={props.Getpasspoetdata} 
                                GetExpData = {props.GetExpData} 
                                GetTechnicalData = {props.GetTechnicalData} 
                                GetComputerData = {props.GetComputerData} 
                                GetAcademicData = {props.GetAcademicData}
                                getdatafromgetter={props.getdatafromgetter}
                                dataforapi={props.dataforapi}
                                checkemptyfun = {checkempty}
                                
                                />}/>
                            </Routes>
                             <Routes>
                                <Route path='ChooseDes' element={<ChooseDesForLoggedInUser id={userdata?.id} AllDesigns={AllDesigns}/>}/>
                            </Routes> 
        
                        </div>
                    </div>
                    <div style={{display:"none"}} className='designs'>
                        <p style={{textAlign:"center", fontSize:"25px",padding:"1.5px", margin:"0", borderBottom:"3px solid black"}}>All Designs</p>
                        <div className='designs_main_cont'>
                            {
                                AllDesigns?.map(
                                    deslink=>(
                                        <a title='Dseignes' onClick={()=>props.Successandrerrorfun("", "Please Fill form to print CV/Resume")}    className='desi_cont'>
                                            <img className='image' alt={deslink.alt} src={deslink.desimage}/>
                                            <p className='imghead'>{deslink.description}</p>
                                        </a>
                                    )
                                )
                            }
                        </div>
                    </div>



                    <div style={{display:"none"}} className='profile'>
                        <h3 className='profile_heading'>My Profile</h3>
                        <div className='profile_main_div' style={{textAlign: "center"}}>
                            <div className='update_avatar'>
                                <form onSubmit={changeabatarhandler}>
                                    <label htmlFor='pic'>Choose Photo</label>
                                    <input type='file' id='pic' onChange={(event)=> setavater(event.target.files[0])}/>
                                    <input type='submit' name='submit'/>
                                </form>
                                <button onClick={hide}>cancel</button>
                            </div>
                            
                    

 

 

                        <div className='avatar_pic' style={{position:"relative"}}>
                            <span className='change_avatar'><i name="Change Photo" className='bx bx-edit-alt' onClick={unhide} style={{fontSize:"30px", cursor:"pointer"}}></i></span>
                            <img className='avatar' src={'https://makeeasyway.in/resumeData/'+userdata?.avatar}/>
                        </div>
                        <p className='profile_ptag'>Name:- <span>{userdata?.fullName}</span></p>
                        <p className='profile_ptag'>Father:- <span>{userdata?.fathername}</span></p>
                        <p className='profile_ptag'>Mother:- <span>{userdata?.mothername}</span></p> 
                        <p className='profile_ptag'>Date Of Birth:- <span>{userdata?.dob}</span></p>
                        <p className='profile_ptag'>Email Id:- <span>{userdata?.email}</span></p>
                        </div>
                    </div>
                    <div style={{display:"none"}} className='setting'>
                        <p style={{textAlign:"center"}}>Comming soon</p>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default UserLogInPage;
